"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrganizationClosingDate = getOrganizationClosingDate;
exports.isQuickBooksAvailableForOrganization = isQuickBooksAvailableForOrganization;
const luxon_1 = require("luxon");
function getOrganizationClosingDate({ fourthPaymentDate, stripeCustomAccountActiveAtUtc, }) {
    const parsedFourthPaymentDate = fourthPaymentDate ? luxon_1.DateTime.fromJSDate(new Date(fourthPaymentDate)) : null;
    const parsedStripeCustomAccountDate = stripeCustomAccountActiveAtUtc
        ? luxon_1.DateTime.fromJSDate(new Date(stripeCustomAccountActiveAtUtc))
        : null;
    if (parsedFourthPaymentDate && parsedStripeCustomAccountDate) {
        return luxon_1.DateTime.max(parsedFourthPaymentDate, parsedStripeCustomAccountDate).toJSDate();
    }
    return null;
}
function isQuickBooksAvailableForOrganization(organization) {
    return !organization.featureTreasuryEnabled && !organization.featurePowerBalanceActivatedAt;
}
